import { render, staticRenderFns } from "./LoyaltyProgram.vue?vue&type=template&id=0cc00555&scoped=true"
import script from "./LoyaltyProgram.vue?vue&type=script&lang=js"
export * from "./LoyaltyProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc00555",
  null
  
)

export default component.exports